import React, { useContext } from 'react';
import styled from 'styled-components';
import { AppContext } from 'src/components/app-context';
import { TitleSmallText, FontColor } from '@prisjakt/ui/text/variants';
import { IconInfoFilled } from '@prisjakt/ui/icon/info-filled';
import { layout } from 'src/components/base';

export const SponsoredBadge = () => {
  const { t } = useContext(AppContext);
  return (
    <SponsoredWrapper>
      <IconInfoFilled />
      <TitleSmallText color={FontColor.PRIMARY}>
        {t('category', 'product-collection.sponsored-product')}
      </TitleSmallText>
    </SponsoredWrapper>
  );
};

export const SponsoredWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  align-items: center;
  padding: ${layout.measurements.spacing025} ${layout.measurements.spacing100} 0;
  svg {
    height: 16px;
    width: 16px;
    margin-right: ${layout.measurements.spacing025};
    path {
      fill: ${p => p.theme.colors.informative700};
    }
  }
`;
